import { isEmpty, forEach, size, join, concat, map, includes, last, get, isArray, values } from 'lodash'
import qs from 'query-string';
import {
  RECALL_FIELD_TO_API_SORT,
  FACET_LOGICAL_OPERATION_MAP,
  PAGE_SIZE,
  SEARCH_FACETS,
  DEFAULT_RECALLS_SORTING,
  SEARCH_FACET_TO_API_PARAMS,
} from '../utils/constants';

const facetIds = values(SEARCH_FACETS);

export const fetchRecalls = (query, config) => {
  const {
    searchTerm = '',
    sort,
    order,
    startDate,
    endDate,
    page = 1,
    locale = '',
  } = query;

  const dataQuery = [];
  const sortQuery = (!isEmpty(sort) && !isEmpty(order))
    ? { sort: get(RECALL_FIELD_TO_API_SORT, sort, sort), order: order.toLowerCase() }
    : DEFAULT_RECALLS_SORTING;

  if (searchTerm) {
    dataQuery.push(searchTerm);
  }

  const conceptQuery = {};
  if (!isEmpty(query)) {
    forEach(query, (val, key) => {
      if (!isEmpty(val) && includes(facetIds, key)) {
        const conceptKey = SEARCH_FACET_TO_API_PARAMS[key];
        if (conceptKey) {
          const currentQuery = get(conceptQuery, conceptKey, '');
          const addToQuery = isArray(val) ? val.join('|') : val;
          conceptQuery[conceptKey] = currentQuery + (isEmpty(currentQuery) ? '' : '|') + addToQuery;
        } else if (isArray(val)) {
          const logicOp = get(FACET_LOGICAL_OPERATION_MAP, key, 'OR');
          dataQuery.push(`(${map(val, x => `${key}:${x}`).join(` ${logicOp} `)})`);
        } else {
          dataQuery.push(`(${key}:${val})`);
        }
      }
    });

    if (!isEmpty(startDate) && !isEmpty(endDate)) {
      dataQuery.push(`date GE ${startDate} AND date LE ${endDate}`)
    }
  }

  const startIndex = ((page - 1) * PAGE_SIZE);
  const onlyUiLangLocales = ['ja', 'es'];
  const queryString = qs.stringify({
    q: dataQuery.join(' '),
    start: startIndex,
    end: startIndex + PAGE_SIZE,
    lang: includes(onlyUiLangLocales, locale) ? 'en' : locale,
    uiLang: locale,
    ...sortQuery,
    ...conceptQuery,
  });

  return fetch(`${config.api}/search.xqy?${queryString}`, {
    mode: 'cors'
  }).then(resp => resp.json());
};

export const fetchRecall = ({ uri, locale = 'en' }, config) => {
  const queryString = qs.stringify({ uri, uiLang: locale });
  return fetch(`${config.api}/getrecall.xqy?${queryString}`, {
    mode: 'cors'
  }).then(resp => resp.json());
};



// WEBPACK FOOTER //
// ./src/utils/recalls-api.js